// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, Client, TDataShape } from './client';
import type { GetAuthData, GetAuthResponses, GetAuthErrors, BrowseStructureData, BrowseStructureResponses, BrowseStructureErrors, GetCategoryData, GetCategoryErrors, ChatData, ChatResponses, ChatErrors, ModelsData, ModelsResponses, ModelsErrors, ListAssignedChecklistsData, ListAssignedChecklistsResponses, ListAssignedChecklistsErrors, ListChecklistTemplatesData, ListChecklistTemplatesResponses, ListChecklistTemplatesErrors, GetConfigurationData, GetConfigurationResponses, GetConfigurationErrors, GetAllCoursesData, GetAllCoursesResponses, GetAllCoursesErrors, AddCourseData, AddCourseResponses, AddCourseErrors, AssignUsersToChecklist1Data, AssignUsersToChecklist1Responses, AssignUsersToChecklist1Errors, ListEnrollmentsByCourseData, ListEnrollmentsByCourseResponses, ListEnrollmentsByCourseErrors, GetComplianceCoursesData, GetComplianceCoursesResponses, GetComplianceCoursesErrors, GenerateCourseReportData, GenerateCourseReportResponses, GenerateCourseReportErrors, GetOperatorCourseSettingsData, GetOperatorCourseSettingsResponses, GetOperatorCourseSettingsErrors, SetOperatorCourseSettingData, SetOperatorCourseSettingResponses, SetOperatorCourseSettingErrors, GetSqsslData, GetSqsslResponses, GetSqsslErrors, SynchronizeUserData, SynchronizeUserResponses, SynchronizeUserErrors, LearnUponWebhookData, LearnUponWebhookResponses, LearnUponWebhookErrors, DeleteCourseData, DeleteCourseResponses, DeleteCourseErrors, UpdateCourseData, UpdateCourseResponses, UpdateCourseErrors, GetCourseByIdData, GetCourseByIdResponses, GetCourseByIdErrors, UpdateUserComplianceCourseDurationData, UpdateUserComplianceCourseDurationResponses, UpdateUserComplianceCourseDurationErrors, SaveDocumentsData, SaveDocumentsResponses, SaveDocumentsErrors, SetAuthCookieData, SetAuthCookieResponses, SetAuthCookieErrors, DeleteDocumentData, DeleteDocumentResponses, DeleteDocumentErrors, GetDocumentData, GetDocumentResponses, GetDocumentErrors, GetCategoryIconsData, GetCategoryIconsResponses, GetCategoryIconsErrors, GetProcedureIconsData, GetProcedureIconsResponses, GetProcedureIconsErrors, GetPlansSummaryData, GetPlansSummaryResponses, GetPlansSummaryErrors, GetPlanReportData, GetPlanReportResponses, GetPlanReportErrors, GetUsersSummaryReportData, GetUsersSummaryReportResponses, GetUsersSummaryReportErrors, GetUserSummaryReportData, GetUserSummaryReportResponses, GetUserSummaryReportErrors, GetManagedPlansData, GetManagedPlansResponses, GetManagedPlansErrors, CreatePlanData, CreatePlanResponses, CreatePlanErrors, GetActivePlanAssignmentsData, GetActivePlanAssignmentsResponses, GetActivePlanAssignmentsErrors, GetSystemPlans1Data, GetSystemPlans1Responses, GetSystemPlans1Errors, GetSystemPlansData, GetSystemPlansResponses, GetSystemPlansErrors, DeletePlanData, DeletePlanResponses, DeletePlanErrors, GetPlanAndAssignmentsData, GetPlanAndAssignmentsResponses, GetPlanAndAssignmentsErrors, UpdatePlanData, UpdatePlanResponses, UpdatePlanErrors, UnassignUsersData, UnassignUsersResponses, UnassignUsersErrors, AssignUsersData, AssignUsersResponses, AssignUsersErrors, PatchAutoAssignData, PatchAutoAssignResponses, PatchAutoAssignErrors, ClonePlanData, ClonePlanResponses, ClonePlanErrors, CloneAsSystemPlanData, CloneAsSystemPlanResponses, CloneAsSystemPlanErrors, UpdateDueDateData, UpdateDueDateResponses, UpdateDueDateErrors, MarkPlanAsCompleteData, MarkPlanAsCompleteResponses, MarkPlanAsCompleteErrors, UpsertReadonlySubscriptionData, UpsertReadonlySubscriptionResponses, UpsertReadonlySubscriptionErrors, ResetPlanStepsData, ResetPlanStepsResponses, ResetPlanStepsErrors, HeartbeatData, HeartbeatResponses, HeartbeatErrors, UpdateStepStatusData, UpdateStepStatusResponses, UpdateStepStatusErrors, HeartbeatTrainTogetherData, HeartbeatTrainTogetherResponses, HeartbeatTrainTogetherErrors, TrainTogetherUpdateStepStatusData, TrainTogetherUpdateStepStatusResponses, TrainTogetherUpdateStepStatusErrors, TrainTogetherMarkPlanAsCompleteData, TrainTogetherMarkPlanAsCompleteResponses, TrainTogetherMarkPlanAsCompleteErrors, GetCustomQuizzesData, GetCustomQuizzesResponses, GetCustomQuizzesErrors, CreateCustomQuizData, CreateCustomQuizResponses, CreateCustomQuizErrors, UpdateCustomQuizData, UpdateCustomQuizResponses, UpdateCustomQuizErrors, DeleteCustomQuizData, DeleteCustomQuizResponses, DeleteCustomQuizErrors, GetCustomQuizDetailsData, GetCustomQuizDetailsResponses, GetCustomQuizDetailsErrors, GetUserTrainingPlansData, GetUserTrainingPlansResponses, GetUserTrainingPlansErrors, ListPlanStatusData, ListPlanStatusResponses, ListPlanStatusErrors, GetResourceData, GetResourceResponses, GetResourceErrors, SearchData, SearchResponses, SearchErrors, SearchClickFeedbackData, SearchClickFeedbackResponses, SearchClickFeedbackErrors, GetTranslationsData, GetTranslationsResponses, GetTranslationsErrors, GetUsersForLocationsData, GetUsersForLocationsResponses, GetUsersForLocationsErrors, GetUsersData, GetUsersResponses, GetUsersErrors, GetOperatorsData, GetOperatorsResponses, GetOperatorsErrors, GetUserPreferencesData, GetUserPreferencesResponses, GetUserPreferencesErrors, SaveUserPreferencesData, SaveUserPreferencesResponses, SaveUserPreferencesErrors, GetUserPlanAssignmentSummariesData, GetUserPlanAssignmentSummariesResponses, GetUserPlanAssignmentSummariesErrors, UpdateChecklistData, UpdateChecklistResponses, UpdateChecklistErrors, ListAllChecklistsData, ListAllChecklistsResponses, ListAllChecklistsErrors, ListAssignableChecklistsData, ListAssignableChecklistsResponses, ListAssignableChecklistsErrors, ListAssignedByChecklistData, ListAssignedByChecklistResponses, ListAssignedByChecklistErrors, ListEditableChecklistsData, ListEditableChecklistsResponses, ListEditableChecklistsErrors, ResetChecklistData, ResetChecklistResponses, ResetChecklistErrors, GetTemplatesData, GetTemplatesResponses, GetTemplatesErrors, CreatePlanFromTemplateData, CreatePlanFromTemplateResponses, CreatePlanFromTemplateErrors, DeleteChecklistData, DeleteChecklistResponses, DeleteChecklistErrors, GetChecklistData, GetChecklistResponses, GetChecklistErrors, DuplicateChecklistData, DuplicateChecklistResponses, DuplicateChecklistErrors, UnassignUsersToChecklistData, UnassignUsersToChecklistResponses, UnassignUsersToChecklistErrors, AssignUsersToChecklistData, AssignUsersToChecklistResponses, AssignUsersToChecklistErrors, SetDueDateOnChecklistData, SetDueDateOnChecklistResponses, SetDueDateOnChecklistErrors, UpdateChecklistStatusData, UpdateChecklistStatusResponses, UpdateChecklistStatusErrors, StepHeartBeatData, StepHeartBeatResponses, StepHeartBeatErrors, UpdateStepStatus1Data, UpdateStepStatus1Responses, UpdateStepStatus1Errors, WebhookQuizData, WebhookQuizResponses, WebhookQuizErrors } from './types.gen';
import { client } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Sets the authorization cookies and returns the users profile / feature set
 */
export const getAuth = <ThrowOnError extends boolean = false>(options?: Options<GetAuthData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAuthResponses, GetAuthErrors, ThrowOnError>({
        url: '/auth',
        ...options
    });
};

/**
 * Get Browse structure
 * Returns complete browse structure by Country and Language
 */
export const browseStructure = <ThrowOnError extends boolean = false>(options?: Options<BrowseStructureData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrowseStructureResponses, BrowseStructureErrors, ThrowOnError>({
        url: '/browse',
        ...options
    });
};

/**
 * Get Category
 */
export const getCategory = <ThrowOnError extends boolean = false>(options: Options<GetCategoryData, ThrowOnError>) => {
    return (options.client ?? client).get<unknown, GetCategoryErrors, ThrowOnError>({
        url: '/categories/{id}',
        ...options
    });
};

/**
 * Streaming chat with the Pathway assistant
 * POST a Vercel AI SDK UI message list; receive a server-sent events stream of UI Message Stream events (token deltas, tool calls, tool outputs, etc.).
 */
export const chat = <ThrowOnError extends boolean = false>(options: Options<ChatData, ThrowOnError>) => {
    return (options.client ?? client).sse.post<ChatResponses, ChatErrors, ThrowOnError>({
        url: '/chat',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List available chat model presets
 * Returns the Gemini model presets the chat endpoint accepts as modelKey.
 */
export const models = <ThrowOnError extends boolean = false>(options?: Options<ModelsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ModelsResponses, ModelsErrors, ThrowOnError>({
        url: '/chat/models',
        ...options
    });
};

/**
 * List assigned training checklists, should only pass V2
 * List assigned training checklists
 * @deprecated
 */
export const listAssignedChecklists = <ThrowOnError extends boolean = false>(options?: Options<ListAssignedChecklistsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListAssignedChecklistsResponses, ListAssignedChecklistsErrors, ThrowOnError>({
        url: '/checklist/assigned',
        ...options
    });
};

/**
 * List all training checklist templates
 * List all training checklist templates
 * @deprecated
 */
export const listChecklistTemplates = <ThrowOnError extends boolean = false>(options?: Options<ListChecklistTemplatesData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListChecklistTemplatesResponses, ListChecklistTemplatesErrors, ThrowOnError>({
        url: '/checklist/templates',
        ...options
    });
};

/**
 * Returns the list of configured versions.
 * Returns the list of configured versions.
 */
export const getConfiguration = <ThrowOnError extends boolean = false>(options?: Options<GetConfigurationData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetConfigurationResponses, GetConfigurationErrors, ThrowOnError>({
        url: '/configuration',
        ...options
    });
};

/**
 * List All Courses
 * List All Courses
 * @deprecated
 */
export const getAllCourses = <ThrowOnError extends boolean = false>(options?: Options<GetAllCoursesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAllCoursesResponses, GetAllCoursesErrors, ThrowOnError>({
        url: '/courses',
        ...options
    });
};

/**
 * Add a Course
 * @deprecated
 */
export const addCourse = <ThrowOnError extends boolean = false>(options: Options<AddCourseData, ThrowOnError>) => {
    return (options.client ?? client).post<AddCourseResponses, AddCourseErrors, ThrowOnError>({
        url: '/courses',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Assign one or more Team members to a Checklist
 * @deprecated
 */
export const assignUsersToChecklist1 = <ThrowOnError extends boolean = false>(options: Options<AssignUsersToChecklist1Data, ThrowOnError>) => {
    return (options.client ?? client).post<AssignUsersToChecklist1Responses, AssignUsersToChecklist1Errors, ThrowOnError>({
        url: '/courses/assign/{courseId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Status of all current enrollments to this course by optional location
 * @deprecated
 */
export const listEnrollmentsByCourse = <ThrowOnError extends boolean = false>(options: Options<ListEnrollmentsByCourseData, ThrowOnError>) => {
    return (options.client ?? client).get<ListEnrollmentsByCourseResponses, ListEnrollmentsByCourseErrors, ThrowOnError>({
        url: '/courses/assigned/{courseId}',
        ...options
    });
};

/**
 * Gets compliance courses based on country selected in user's profile
 * @deprecated
 */
export const getComplianceCourses = <ThrowOnError extends boolean = false>(options?: Options<GetComplianceCoursesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetComplianceCoursesResponses, GetComplianceCoursesErrors, ThrowOnError>({
        url: '/courses/compliance',
        ...options
    });
};

/**
 * Sensitive data report on course by location
 * @deprecated
 */
export const generateCourseReport = <ThrowOnError extends boolean = false>(options: Options<GenerateCourseReportData, ThrowOnError>) => {
    return (options.client ?? client).get<GenerateCourseReportResponses, GenerateCourseReportErrors, ThrowOnError>({
        url: '/courses/report/{courseId}',
        ...options
    });
};

/**
 * Returns course settings for an operator
 * @deprecated
 */
export const getOperatorCourseSettings = <ThrowOnError extends boolean = false>(options: Options<GetOperatorCourseSettingsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetOperatorCourseSettingsResponses, GetOperatorCourseSettingsErrors, ThrowOnError>({
        url: '/courses/settings',
        ...options
    });
};

/**
 * Enables or Disables a course for an operator
 * @deprecated
 */
export const setOperatorCourseSetting = <ThrowOnError extends boolean = false>(options: Options<SetOperatorCourseSettingData, ThrowOnError>) => {
    return (options.client ?? client).post<SetOperatorCourseSettingResponses, SetOperatorCourseSettingErrors, ThrowOnError>({
        url: '/courses/settings/{courseId}/{enable}',
        ...options
    });
};

/**
 * Get SQSSO
 * @deprecated
 */
export const getSqssl = <ThrowOnError extends boolean = false>(options: Options<GetSqsslData, ThrowOnError>) => {
    return (options.client ?? client).get<GetSqsslResponses, GetSqsslErrors, ThrowOnError>({
        url: '/courses/sqsso/{courseId}',
        ...options
    });
};

/**
 * Synchronize User with LearnUpon
 * @deprecated
 */
export const synchronizeUser = <ThrowOnError extends boolean = false>(options: Options<SynchronizeUserData, ThrowOnError>) => {
    return (options.client ?? client).post<SynchronizeUserResponses, SynchronizeUserErrors, ThrowOnError>({
        url: '/courses/sync/{userId}',
        ...options
    });
};

/**
 * Handle LearnUpon webhook event
 * @deprecated
 */
export const learnUponWebhook = <ThrowOnError extends boolean = false>(options: Options<LearnUponWebhookData, ThrowOnError>) => {
    return (options.client ?? client).post<LearnUponWebhookResponses, LearnUponWebhookErrors, ThrowOnError>({
        url: '/courses/webhook',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete Course by ID
 * @deprecated
 */
export const deleteCourse = <ThrowOnError extends boolean = false>(options: Options<DeleteCourseData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteCourseResponses, DeleteCourseErrors, ThrowOnError>({
        url: '/courses/{id}',
        ...options
    });
};

/**
 * Update a course
 * @deprecated
 */
export const updateCourse = <ThrowOnError extends boolean = false>(options: Options<UpdateCourseData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateCourseResponses, UpdateCourseErrors, ThrowOnError>({
        url: '/courses/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Course by ID
 * @deprecated
 */
export const getCourseById = <ThrowOnError extends boolean = false>(options: Options<GetCourseByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetCourseByIdResponses, GetCourseByIdErrors, ThrowOnError>({
        url: '/courses/{itemId}',
        ...options
    });
};

/**
 * Set course status by ID
 * @deprecated
 */
export const updateUserComplianceCourseDuration = <ThrowOnError extends boolean = false>(options: Options<UpdateUserComplianceCourseDurationData, ThrowOnError>) => {
    return (options.client ?? client).post<UpdateUserComplianceCourseDurationResponses, UpdateUserComplianceCourseDurationErrors, ThrowOnError>({
        url: '/courses/{pathwayCourseId}/heartbeat',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Add or update documents
 */
export const saveDocuments = <ThrowOnError extends boolean = false>(options: Options<SaveDocumentsData, ThrowOnError>) => {
    return (options.client ?? client).post<SaveDocumentsResponses, SaveDocumentsErrors, ThrowOnError>({
        url: '/documents',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Sets auth cookie in response header
 */
export const setAuthCookie = <ThrowOnError extends boolean = false>(options?: Options<SetAuthCookieData, ThrowOnError>) => {
    return (options?.client ?? client).get<SetAuthCookieResponses, SetAuthCookieErrors, ThrowOnError>({
        url: '/documents/cookie',
        ...options
    });
};

/**
 * Delete document by ID
 */
export const deleteDocument = <ThrowOnError extends boolean = false>(options?: Options<DeleteDocumentData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteDocumentResponses, DeleteDocumentErrors, ThrowOnError>({
        url: '/documents/{itemId}',
        ...options
    });
};

/**
 * Get document by ID
 */
export const getDocument = <ThrowOnError extends boolean = false>(options: Options<GetDocumentData, ThrowOnError>) => {
    return (options.client ?? client).get<GetDocumentResponses, GetDocumentErrors, ThrowOnError>({
        url: '/documents/{itemId}',
        ...options
    });
};

/**
 * Get a list of all category icons
 */
export const getCategoryIcons = <ThrowOnError extends boolean = false>(options?: Options<GetCategoryIconsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetCategoryIconsResponses, GetCategoryIconsErrors, ThrowOnError>({
        url: '/icons/categories',
        ...options
    });
};

/**
 * Get a list of all procedure icons
 */
export const getProcedureIcons = <ThrowOnError extends boolean = false>(options?: Options<GetProcedureIconsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetProcedureIconsResponses, GetProcedureIconsErrors, ThrowOnError>({
        url: '/icons/procedures',
        ...options
    });
};

/**
 * Get a report on all plans a user has build access to
 * Get a report on all plans a user has build access to, status default is ACTIVE
 */
export const getPlansSummary = <ThrowOnError extends boolean = false>(options?: Options<GetPlansSummaryData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetPlansSummaryResponses, GetPlansSummaryErrors, ThrowOnError>({
        url: '/planReports/plans',
        ...options
    });
};

/**
 * Get a report for all users on a specific plan
 * Get a report for all users on a specific plan
 */
export const getPlanReport = <ThrowOnError extends boolean = false>(options: Options<GetPlanReportData, ThrowOnError>) => {
    return (options.client ?? client).get<GetPlanReportResponses, GetPlanReportErrors, ThrowOnError>({
        url: '/planReports/plans/{planId}',
        ...options
    });
};

/**
 * Get a report on all users plan progress for the passed in location numbers.
 * Returns summary of user's overall plan progress on all active plans at the passed in location numbers.
 */
export const getUsersSummaryReport = <ThrowOnError extends boolean = false>(options?: Options<GetUsersSummaryReportData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetUsersSummaryReportResponses, GetUsersSummaryReportErrors, ThrowOnError>({
        url: '/planReports/users',
        ...options
    });
};

/**
 * Get a detailed plan summary report for a specific user
 * Get a detailed plan summary report for a specific user
 */
export const getUserSummaryReport = <ThrowOnError extends boolean = false>(options: Options<GetUserSummaryReportData, ThrowOnError>) => {
    return (options.client ?? client).get<GetUserSummaryReportResponses, GetUserSummaryReportErrors, ThrowOnError>({
        url: '/planReports/users/{userId}',
        ...options
    });
};

/**
 * Get manage plans for user's owner ids
 * Get manage plans for logged in user's owner ids
 */
export const getManagedPlans = <ThrowOnError extends boolean = false>(options?: Options<GetManagedPlansData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetManagedPlansResponses, GetManagedPlansErrors, ThrowOnError>({
        url: '/plans',
        ...options
    });
};

/**
 * Create a new plan.
 */
export const createPlan = <ThrowOnError extends boolean = false>(options: Options<CreatePlanData, ThrowOnError>) => {
    return (options.client ?? client).post<CreatePlanResponses, CreatePlanErrors, ThrowOnError>({
        url: '/plans',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get active assigned plans for user
 * Get active assigned plans for logged in user
 */
export const getActivePlanAssignments = <ThrowOnError extends boolean = false>(options?: Options<GetActivePlanAssignmentsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetActivePlanAssignmentsResponses, GetActivePlanAssignmentsErrors, ThrowOnError>({
        url: '/plans/assignments',
        ...options
    });
};

/**
 * Get system plans for user's business models
 * Get system plans for logged in user's business models
 */
export const getSystemPlans1 = <ThrowOnError extends boolean = false>(options?: Options<GetSystemPlans1Data, ThrowOnError>) => {
    return (options?.client ?? client).get<GetSystemPlans1Responses, GetSystemPlans1Errors, ThrowOnError>({
        url: '/plans/system',
        ...options
    });
};

/**
 * Get system plans for user's business models
 * Get system plans for logged in user's business models
 */
export const getSystemPlans = <ThrowOnError extends boolean = false>(options?: Options<GetSystemPlansData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetSystemPlansResponses, GetSystemPlansErrors, ThrowOnError>({
        url: '/plans/templates',
        ...options
    });
};

/**
 * Delete a plan.
 */
export const deletePlan = <ThrowOnError extends boolean = false>(options: Options<DeletePlanData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeletePlanResponses, DeletePlanErrors, ThrowOnError>({
        url: '/plans/{planId}',
        ...options
    });
};

/**
 * Get plan by id along with all of its active assignments
 * Get plan by id along with all of its active assignments
 */
export const getPlanAndAssignments = <ThrowOnError extends boolean = false>(options: Options<GetPlanAndAssignmentsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetPlanAndAssignmentsResponses, GetPlanAndAssignmentsErrors, ThrowOnError>({
        url: '/plans/{planId}',
        ...options
    });
};

/**
 * Update a plan.
 */
export const updatePlan = <ThrowOnError extends boolean = false>(options: Options<UpdatePlanData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdatePlanResponses, UpdatePlanErrors, ThrowOnError>({
        url: '/plans/{planId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Unassign users from plan.
 */
export const unassignUsers = <ThrowOnError extends boolean = false>(options: Options<UnassignUsersData, ThrowOnError>) => {
    return (options.client ?? client).delete<UnassignUsersResponses, UnassignUsersErrors, ThrowOnError>({
        url: '/plans/{planId}/assignments',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Assign plan to users.
 */
export const assignUsers = <ThrowOnError extends boolean = false>(options: Options<AssignUsersData, ThrowOnError>) => {
    return (options.client ?? client).post<AssignUsersResponses, AssignUsersErrors, ThrowOnError>({
        url: '/plans/{planId}/assignments',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Mark a plan as auto assignable.
 * Allows a user to mark a plan as auto assignable.
 */
export const patchAutoAssign = <ThrowOnError extends boolean = false>(options: Options<PatchAutoAssignData, ThrowOnError>) => {
    return (options.client ?? client).patch<PatchAutoAssignResponses, PatchAutoAssignErrors, ThrowOnError>({
        url: '/plans/{planId}/autoAssign',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Clone a plan.
 */
export const clonePlan = <ThrowOnError extends boolean = false>(options: Options<ClonePlanData, ThrowOnError>) => {
    return (options.client ?? client).post<ClonePlanResponses, ClonePlanErrors, ThrowOnError>({
        url: '/plans/{planId}/clone',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Clone a plan as a system plan.
 */
export const cloneAsSystemPlan = <ThrowOnError extends boolean = false>(options: Options<CloneAsSystemPlanData, ThrowOnError>) => {
    return (options.client ?? client).post<CloneAsSystemPlanResponses, CloneAsSystemPlanErrors, ThrowOnError>({
        url: '/plans/{planId}/clone/asSystem',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update a users plan due date.
 * Changes when a user's plan is due by.
 */
export const updateDueDate = <ThrowOnError extends boolean = false>(options: Options<UpdateDueDateData, ThrowOnError>) => {
    return (options.client ?? client).patch<UpdateDueDateResponses, UpdateDueDateErrors, ThrowOnError>({
        url: '/plans/{planId}/dueDate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Mark plan as complete when all steps are complete.
 * Records when a user is complete with a plan.
 */
export const markPlanAsComplete = <ThrowOnError extends boolean = false>(options: Options<MarkPlanAsCompleteData, ThrowOnError>) => {
    return (options.client ?? client).patch<MarkPlanAsCompleteResponses, MarkPlanAsCompleteErrors, ThrowOnError>({
        url: '/plans/{planId}/markAsComplete',
        ...options
    });
};

/**
 * Allow users to opt-in or out of readonly plans.
 * Subscribes a location/operator to a readonly plan.
 */
export const upsertReadonlySubscription = <ThrowOnError extends boolean = false>(options: Options<UpsertReadonlySubscriptionData, ThrowOnError>) => {
    return (options.client ?? client).put<UpsertReadonlySubscriptionResponses, UpsertReadonlySubscriptionErrors, ThrowOnError>({
        url: '/plans/{planId}/readonly/subscription',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Resets all the steps in a plan.
 * Resets all the steps in a plan to incomplete.
 */
export const resetPlanSteps = <ThrowOnError extends boolean = false>(options: Options<ResetPlanStepsData, ThrowOnError>) => {
    return (options.client ?? client).put<ResetPlanStepsResponses, ResetPlanStepsErrors, ThrowOnError>({
        url: '/plans/{planId}/steps/reset',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update duration for logged in user's plan and step.
 * Records how long a user takes on a given plan and step.
 */
export const heartbeat = <ThrowOnError extends boolean = false>(options: Options<HeartbeatData, ThrowOnError>) => {
    return (options.client ?? client).put<HeartbeatResponses, HeartbeatErrors, ThrowOnError>({
        url: '/plans/{planId}/steps/{stepId}/heartbeat',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Updates a step status to complete.
 * Updates a single step status to complete.
 */
export const updateStepStatus = <ThrowOnError extends boolean = false>(options: Options<UpdateStepStatusData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateStepStatusResponses, UpdateStepStatusErrors, ThrowOnError>({
        url: '/plans/{planId}/steps/{stepId}/status',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update duration for passed in user's plan and step in train together.
 * Records how long the passed in users take on the given plan and step in train together.
 */
export const heartbeatTrainTogether = <ThrowOnError extends boolean = false>(options: Options<HeartbeatTrainTogetherData, ThrowOnError>) => {
    return (options.client ?? client).put<HeartbeatTrainTogetherResponses, HeartbeatTrainTogetherErrors, ThrowOnError>({
        url: '/plans/{planId}/steps/{stepId}/trainTogether/heartbeat',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Mark the passed in plan's step status for the user ids in training mode.
 */
export const trainTogetherUpdateStepStatus = <ThrowOnError extends boolean = false>(options: Options<TrainTogetherUpdateStepStatusData, ThrowOnError>) => {
    return (options.client ?? client).put<TrainTogetherUpdateStepStatusResponses, TrainTogetherUpdateStepStatusErrors, ThrowOnError>({
        url: '/plans/{planId}/steps/{stepId}/trainTogether/status',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Mark plan as complete for the passed user ids in training together.
 * Records when a user is complete with a plan in training together.
 */
export const trainTogetherMarkPlanAsComplete = <ThrowOnError extends boolean = false>(options: Options<TrainTogetherMarkPlanAsCompleteData, ThrowOnError>) => {
    return (options.client ?? client).patch<TrainTogetherMarkPlanAsCompleteResponses, TrainTogetherMarkPlanAsCompleteErrors, ThrowOnError>({
        url: '/plans/{planId}/trainTogether/markAsComplete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Gets a list of custom quizzes
 * Gets a list of custom quizzes
 */
export const getCustomQuizzes = <ThrowOnError extends boolean = false>(options?: Options<GetCustomQuizzesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetCustomQuizzesResponses, GetCustomQuizzesErrors, ThrowOnError>({
        url: '/quiz',
        ...options
    });
};

/**
 * Create a custom quiz
 */
export const createCustomQuiz = <ThrowOnError extends boolean = false>(options: Options<CreateCustomQuizData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateCustomQuizResponses, CreateCustomQuizErrors, ThrowOnError>({
        url: '/quiz',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Edit a custom quiz
 */
export const updateCustomQuiz = <ThrowOnError extends boolean = false>(options: Options<UpdateCustomQuizData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateCustomQuizResponses, UpdateCustomQuizErrors, ThrowOnError>({
        url: '/quiz',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete custom quiz
 */
export const deleteCustomQuiz = <ThrowOnError extends boolean = false>(options: Options<DeleteCustomQuizData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteCustomQuizResponses, DeleteCustomQuizErrors, ThrowOnError>({
        url: '/quiz/{customQuizId}',
        ...options
    });
};

/**
 * Get custom quiz details
 */
export const getCustomQuizDetails = <ThrowOnError extends boolean = false>(options: Options<GetCustomQuizDetailsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetCustomQuizDetailsResponses, GetCustomQuizDetailsErrors, ThrowOnError>({
        url: '/quiz/{customQuizId}',
        ...options
    });
};

/**
 * Get user's training plans by userId
 * @deprecated
 */
export const getUserTrainingPlans = <ThrowOnError extends boolean = false>(options: Options<GetUserTrainingPlansData, ThrowOnError>) => {
    return (options.client ?? client).get<GetUserTrainingPlansResponses, GetUserTrainingPlansErrors, ThrowOnError>({
        url: '/reports/training/teamMember/{adId}',
        ...options
    });
};

/**
 * Get training plan statuses by location
 * Get training plan statuses by location
 * @deprecated
 */
export const listPlanStatus = <ThrowOnError extends boolean = false>(options?: Options<ListPlanStatusData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListPlanStatusResponses, ListPlanStatusErrors, ThrowOnError>({
        url: '/reports/training/teamMembers',
        ...options
    });
};

/**
 * Get a resource
 * Returns complete resource structure by id
 */
export const getResource = <ThrowOnError extends boolean = false>(options: Options<GetResourceData, ThrowOnError>) => {
    return (options.client ?? client).get<GetResourceResponses, GetResourceErrors, ThrowOnError>({
        url: '/resources/{id}',
        ...options
    });
};

/**
 * Search for results
 * Searches for resources by query, country and language. Returns document results along with optional GenAI smart answers. Smart answers include source attribution with document titles, URLs, text excerpts, and confidence scores.
 */
export const search = <ThrowOnError extends boolean = false>(options: Options<SearchData, ThrowOnError>) => {
    return (options.client ?? client).get<SearchResponses, SearchErrors, ThrowOnError>({
        url: '/search',
        ...options
    });
};

/**
 * Submit click feedback for a result
 * Improves search results by submitting click feedback for a specific result and query.
 */
export const searchClickFeedback = <ThrowOnError extends boolean = false>(options: Options<SearchClickFeedbackData, ThrowOnError>) => {
    return (options.client ?? client).post<SearchClickFeedbackResponses, SearchClickFeedbackErrors, ThrowOnError>({
        url: '/search-click-feedback',
        ...options
    });
};

/**
 * Get Natural Language Translations
 * Facilitates translation from one natural language to another.
 */
export const getTranslations = <ThrowOnError extends boolean = false>(options: Options<GetTranslationsData, ThrowOnError>) => {
    return (options.client ?? client).post<GetTranslationsResponses, GetTranslationsErrors, ThrowOnError>({
        url: '/translate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Find users assigned to locations
 * Find users assigned to locations.
 */
export const getUsersForLocations = <ThrowOnError extends boolean = false>(options?: Options<GetUsersForLocationsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetUsersForLocationsResponses, GetUsersForLocationsErrors, ThrowOnError>({
        url: '/users',
        ...options
    });
};

/**
 * Get users by locations
 * @deprecated
 */
export const getUsers = <ThrowOnError extends boolean = false>(options?: Options<GetUsersData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetUsersResponses, GetUsersErrors, ThrowOnError>({
        url: '/users/list',
        ...options
    });
};

/**
 * Get operators and locations
 */
export const getOperators = <ThrowOnError extends boolean = false>(options?: Options<GetOperatorsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetOperatorsResponses, GetOperatorsErrors, ThrowOnError>({
        url: '/users/operators',
        ...options
    });
};

/**
 * Retrieve user preferences
 */
export const getUserPreferences = <ThrowOnError extends boolean = false>(options?: Options<GetUserPreferencesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetUserPreferencesResponses, GetUserPreferencesErrors, ThrowOnError>({
        url: '/users/preferences',
        ...options
    });
};

/**
 * Save user preferences
 */
export const saveUserPreferences = <ThrowOnError extends boolean = false>(options: Options<SaveUserPreferencesData, ThrowOnError>) => {
    return (options.client ?? client).post<SaveUserPreferencesResponses, SaveUserPreferencesErrors, ThrowOnError>({
        url: '/users/preferences',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get User Plan Assignment Summaries
 * Returns a summary of the user's plan assignments.
 */
export const getUserPlanAssignmentSummaries = <ThrowOnError extends boolean = false>(options: Options<GetUserPlanAssignmentSummariesData, ThrowOnError>) => {
    return (options.client ?? client).get<GetUserPlanAssignmentSummariesResponses, GetUserPlanAssignmentSummariesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/users/{userId}/plans/assignments',
        ...options
    });
};

/**
 * Update a checklist
 * Update a checklist
 * @deprecated
 */
export const updateChecklist = <ThrowOnError extends boolean = false>(options: Options<UpdateChecklistData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateChecklistResponses, UpdateChecklistErrors, ThrowOnError>({
        url: '/v2/checklist',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List all training checklists
 * List all training checklists
 * @deprecated
 */
export const listAllChecklists = <ThrowOnError extends boolean = false>(options?: Options<ListAllChecklistsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListAllChecklistsResponses, ListAllChecklistsErrors, ThrowOnError>({
        url: '/v2/checklist/all',
        ...options
    });
};

/**
 * List all training checklists the active user can assign with their assigned counts
 * List all training checklists the active user can assign with their assigned counts
 * @deprecated
 */
export const listAssignableChecklists = <ThrowOnError extends boolean = false>(options?: Options<ListAssignableChecklistsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListAssignableChecklistsResponses, ListAssignableChecklistsErrors, ThrowOnError>({
        url: '/v2/checklist/assignable',
        ...options
    });
};

/**
 * Status of all assigned users to this training checklist
 * Status of all assigned users to this training checklist
 * @deprecated
 */
export const listAssignedByChecklist = <ThrowOnError extends boolean = false>(options: Options<ListAssignedByChecklistData, ThrowOnError>) => {
    return (options.client ?? client).get<ListAssignedByChecklistResponses, ListAssignedByChecklistErrors, ThrowOnError>({
        url: '/v2/checklist/assigned/{checklistId}',
        ...options
    });
};

/**
 * List all training checklists the active user can edit/modify
 * List all training checklists the active user can edit/modify
 * @deprecated
 */
export const listEditableChecklists = <ThrowOnError extends boolean = false>(options?: Options<ListEditableChecklistsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListEditableChecklistsResponses, ListEditableChecklistsErrors, ThrowOnError>({
        url: '/v2/checklist/editable',
        ...options
    });
};

/**
 * Reset current state of checklist for users
 * Reset current state of checklist for users
 * @deprecated
 */
export const resetChecklist = <ThrowOnError extends boolean = false>(options: Options<ResetChecklistData, ThrowOnError>) => {
    return (options.client ?? client).post<ResetChecklistResponses, ResetChecklistErrors, ThrowOnError>({
        url: '/v2/checklist/reset',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get all plan templates
 *    The type of templates returned depend on the audience. Licensee users will only see `LICENSEE` templates
 * and all other users will see `FRANCHISEE` templates (this includes operator consultants and brand
 * champions).
 *
 * @deprecated
 */
export const getTemplates = <ThrowOnError extends boolean = false>(options?: Options<GetTemplatesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetTemplatesResponses, GetTemplatesErrors, ThrowOnError>({
        url: '/v2/checklist/templates',
        ...options
    });
};

/**
 * Create a plan from a template
 * Create a plan from a template
 * @deprecated
 */
export const createPlanFromTemplate = <ThrowOnError extends boolean = false>(options: Options<CreatePlanFromTemplateData, ThrowOnError>) => {
    return (options.client ?? client).post<CreatePlanFromTemplateResponses, CreatePlanFromTemplateErrors, ThrowOnError>({
        url: '/v2/checklist/templates/{templateId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete a checklist
 * Delete a checklist
 * @deprecated
 */
export const deleteChecklist = <ThrowOnError extends boolean = false>(options: Options<DeleteChecklistData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteChecklistResponses, DeleteChecklistErrors, ThrowOnError>({
        url: '/v2/checklist/{checklistId}',
        ...options
    });
};

/**
 * Get checklist by id
 * Get checklist by id
 * @deprecated
 */
export const getChecklist = <ThrowOnError extends boolean = false>(options: Options<GetChecklistData, ThrowOnError>) => {
    return (options.client ?? client).get<GetChecklistResponses, GetChecklistErrors, ThrowOnError>({
        url: '/v2/checklist/{checklistId}',
        ...options
    });
};

/**
 * Duplicate a checklist
 * Duplicate a checklist
 * @deprecated
 */
export const duplicateChecklist = <ThrowOnError extends boolean = false>(options: Options<DuplicateChecklistData, ThrowOnError>) => {
    return (options.client ?? client).post<DuplicateChecklistResponses, DuplicateChecklistErrors, ThrowOnError>({
        url: '/v2/checklist/{checklistId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Unassign one or more team members to a checklist
 * Unassign one or more team members to a checklist
 * @deprecated
 */
export const unassignUsersToChecklist = <ThrowOnError extends boolean = false>(options: Options<UnassignUsersToChecklistData, ThrowOnError>) => {
    return (options.client ?? client).delete<UnassignUsersToChecklistResponses, UnassignUsersToChecklistErrors, ThrowOnError>({
        url: '/v2/checklist/{checklistId}/assign',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Assign one or more team members to a checklist
 * Assign one or more team members to a checklist
 * @deprecated
 */
export const assignUsersToChecklist = <ThrowOnError extends boolean = false>(options: Options<AssignUsersToChecklistData, ThrowOnError>) => {
    return (options.client ?? client).post<AssignUsersToChecklistResponses, AssignUsersToChecklistErrors, ThrowOnError>({
        url: '/v2/checklist/{checklistId}/assign',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Set due date on one or more team members assigned to a checklist
 * Set due date on one or more team members assigned to a checklist
 * @deprecated
 */
export const setDueDateOnChecklist = <ThrowOnError extends boolean = false>(options: Options<SetDueDateOnChecklistData, ThrowOnError>) => {
    return (options.client ?? client).post<SetDueDateOnChecklistResponses, SetDueDateOnChecklistErrors, ThrowOnError>({
        url: '/v2/checklist/{checklistId}/dueDate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update checklist status
 * Update checklist status
 * @deprecated
 */
export const updateChecklistStatus = <ThrowOnError extends boolean = false>(options: Options<UpdateChecklistStatusData, ThrowOnError>) => {
    return (options.client ?? client).post<UpdateChecklistStatusResponses, UpdateChecklistStatusErrors, ThrowOnError>({
        url: '/v2/checklist/{checklistId}/status',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Increment the time a user or trainer has spent on a checklist step via heartbeat mechanism
 * Increment the time a user or trainer has spent on a checklist step via heartbeat mechanism
 * @deprecated
 */
export const stepHeartBeat = <ThrowOnError extends boolean = false>(options: Options<StepHeartBeatData, ThrowOnError>) => {
    return (options.client ?? client).post<StepHeartBeatResponses, StepHeartBeatErrors, ThrowOnError>({
        url: '/v2/checklist/{checklistId}/steps/{stepId}/heartbeat',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update a checklist step status for a user or trainer
 * Update a checklist step status for a user or trainer
 * @deprecated
 */
export const updateStepStatus1 = <ThrowOnError extends boolean = false>(options: Options<UpdateStepStatus1Data, ThrowOnError>) => {
    return (options.client ?? client).post<UpdateStepStatus1Responses, UpdateStepStatus1Errors, ThrowOnError>({
        url: '/v2/checklist/{checklistId}/steps/{stepId}/status',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Store quiz results for plan from Typeform
 */
export const webhookQuiz = <ThrowOnError extends boolean = false>(options: Options<WebhookQuizData, ThrowOnError>) => {
    return (options.client ?? client).post<WebhookQuizResponses, WebhookQuizErrors, ThrowOnError>({
        url: '/webhook/plans/quiz',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
